export const firstDayOfCurrentMonth = () => {
  const firstDayOfMonth = new Date();
  firstDayOfMonth.setDate(firstDayOfMonth.getDate() - firstDayOfMonth.getDate() + 1);
  firstDayOfMonth.setHours(0, 0, 0, 0);
  return firstDayOfMonth;
};
